import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { base64ToFile, Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { MessageService } from 'primeng/api';
import { CommonUtilities } from '../../assets/js/common-utilities';
declare var $: any;

@Component({
  selector: 'app-all-components',
  templateUrl: './all-components.component.html',
  styleUrls: ['./all-components.component.css']
})
export class AllComponentsComponent implements OnInit {
  first: number = 0;

  totalRecords: number = 12;
  imgType: any;
  today= new Date();

  onPageChange(event) {
      this.first = event.first;
      console.log(this.first);
  }
  
  selectedCities: string[] = [];
  city: string;
  checked1: boolean = false;
  disabled: boolean = true;
  displayBasic: boolean;
  displayBasic1: boolean;
  imageCropperTool: boolean;
  position: string;
  defaultDate: Date;
  uploadedFiles: any[] = [];

  _LastAddedGridDocument: File;
  fileUpload: any;
  imageChangedEvent: any;
  croppedImage: any = '';
  canvasRotation = 0;
  rotation = 0;
  scale = 1;
  showCropper = false;
  containWithinAspectRatio = false;
  transform: ImageTransform = {};
  file: any;
  size:any;
  width:number;
  height:number;

  showBasicDialog(position: string) {
    this.position = position;
    this.displayBasic = true;
  }
  showBasicDialog1() {
    this.displayBasic1 = true;
  }
  RemoveFile() {
    //this.uploadedFiles.push(file);
  }
  checkValidation(evt: any){
    let image:any = evt.target.files[0];
   this.size = image.size;
   let fr = new FileReader;
   fr.onload = () => { // when file has loaded
    var img = new Image();

    img.onload = () => {
      this.width = img.width;
      this.height = img.height;
      console.log("Width:",this.width)
      console.log("Height:",this.height)
      if ((this.width <= 580) || (this.height <= 285)){
        alert('error');
      }
      else{
        this.fileChangeEvent(event);
      }
    };
    img.src = fr.result as string; // This is the data URL 
    // this.imgType.nativeElement.value = '';
  }
  fr.readAsDataURL(image);
}
  
  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    console.log("Image", this.imageChangedEvent);
    // var fileInput = $(this).find("input[type=file]")[0],
    //     file = fileInput.files && fileInput.files[0];
    // alert(file);
    // console.log("Image Size", this.path[0].value);
    this.imageCropperTool = true;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    console.log(event, base64ToFile(event.base64));
  }

  imageLoaded() {
    this.showCropper = true;
    console.log('Image loaded');
  }

  cropperReady(sourceImageDimensions: Dimensions) {
    console.log('Cropper ready', sourceImageDimensions);
  }

  onSave() {
    var imgWidth = $('.source-image').width();
    var imgheight = $('.source-image').height();
    alert('Cropper ready Width : ' + imgWidth + ' Cropper ready Height : ' + imgheight);
  }

  loadImageFailed() {
    console.log('Load failed');
  }
  resetImage() {
    this.scale = 1;
    this.rotation = 0;
    this.canvasRotation = 0;
    this.transform = {};
  }
  zoomOut() {
    this.scale -= .1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  zoomIn() {
    this.scale += .1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }
  // sec:number;
  date=formatDate(this.today, "dd-MM-yyyy hh:mm:ss a", "en-US", "+0200");
  time=formatDate(this.today, "hh:mm:ss a", "en-US", "+0200");
  sec=Math.floor(new Date().getTime() / 1000);
  ms=Date.now();
  // alert(date);
  // alert(time);

  constructor(private utility: CommonUtilities, private messageService: MessageService) { }

  ngOnInit(): void {
    this.utility.pageLoadScript();
    this.defaultDate = new Date();
    $(document).on("change", ".file-upload-field", function () {
      $(this).parent(".file-upload-wrapper").attr("data-text", $(this).val().replace(/.*(\/|\\)/, ''));
    });
  }
}
